module.exports = __webpack_public_path__ + "d6d4bcb57db6f8319dafe1a5a3023a3f.svg";